import { render } from "./CxPromos.vue?vue&type=template&id=32601130&scoped=true"
import script from "./CxPromos.vue?vue&type=script&lang=js"
export * from "./CxPromos.vue?vue&type=script&lang=js"

import "./CxPromos.vue?vue&type=style&index=0&id=32601130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32601130"]])

export default __exports__